export interface WordSpan {
  start: number;
  end: number;
  text: string;
}

/** Split text into word spans (spaces between words are not included). */
export function splitWords(text: string): WordSpan[] {
  const out: WordSpan[] = [];
  let i = 0;
  while (i < text.length) {
    while (i < text.length && text[i] === ' ') i++;
    if (i >= text.length) break;
    const start = i;
    while (i < text.length && text[i] !== ' ') i++;
    out.push({ start, end: i, text: text.slice(start, i) });
  }
  return out;
}

export function wordIndexAtCursor(
  words: ReadonlyArray<WordSpan>,
  cursor: number,
): number {
  for (let i = 0; i < words.length; i++) {
    if (cursor >= words[i].start && cursor < words[i].end) return i;
  }
  return -1;
}

/** Word whose trailing space is at `cursor` (cursor between words). */
export function wordIndexBeforeSpace(
  words: ReadonlyArray<WordSpan>,
  cursor: number,
): number {
  for (let i = 0; i < words.length; i++) {
    if (words[i].end === cursor) return i;
  }
  return -1;
}

/**
 * Word shown in the UI while typing or while awaiting space after a word.
 * Avoids jumping to the next word when the cursor sits on a space character.
 */
export function activeWordIndex(
  words: ReadonlyArray<WordSpan>,
  cursor: number,
  awaitingSpace: boolean,
): number {
  if (awaitingSpace) {
    const before = wordIndexBeforeSpace(words, cursor);
    if (before >= 0) return before;
  }
  const inside = wordIndexAtCursor(words, cursor);
  if (inside >= 0) return inside;
  if (words.length === 0) return -1;
  if (cursor >= words[words.length - 1].end) return words.length - 1;
  return 0;
}
